/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusProfilbildLimitsDto } from '../../models/lexplus-profilbild-limits-dto';

export interface BenutzerverwaltungControllerGetProfilbildLimitsV1$Params {
}

export function benutzerverwaltungControllerGetProfilbildLimitsV1(http: HttpClient, rootUrl: string, params?: BenutzerverwaltungControllerGetProfilbildLimitsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusProfilbildLimitsDto>> {
  const rb = new RequestBuilder(rootUrl, benutzerverwaltungControllerGetProfilbildLimitsV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusProfilbildLimitsDto>;
    })
  );
}

benutzerverwaltungControllerGetProfilbildLimitsV1.PATH = '/v1/benutzerverwaltung/profilbild-limits';
